<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="文章标题" prop="articleTitle" >
        <a-input v-model="form.articleTitle" placeholder="请输入文章标题" />
      </a-form-model-item>
      <a-form-model-item label="文章类型" prop="articleType">
        <a-select v-model="form.articleType" placeholder="请选择文章类型">
          <a-select-option :value="1">学习中心</a-select-option>
          <a-select-option :value="2">抢单规则</a-select-option>
          <a-select-option :value="3">其他</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="文章封面" prop="imgs">
        <file-upload
          :key="'article-cover-' + formKey"
          type="image"
          :default-list="form.imgsArr"
          :count="1"
          @input="getImg($event, 'imgs')"
        />
      </a-form-model-item>
      <a-form-model-item label="文章内容" prop="articleContent" >
        <editor :key="formKey" v-model="form.articleContent" />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sortNum" >
        <a-input v-model="form.sortNum" placeholder="请输入排序" />
      </a-form-model-item>
      <a-form-model-item label="是否启用" prop="enabled">
        <a-select v-model="form.enabled" :placeholder="'请选择'">
          <a-select-option :value="0">否</a-select-option>
          <a-select-option :value="1">是</a-select-option>
        </a-select>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { addArticle, getArticle, updateArticle } from '@/api/article/article'
import Editor from '@/components/Editor'
import { guid } from '@/utils/ruoyi'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        articleTitle: null,

        articleType: null,

        articleContent: null,

        readNum: null,

        sortNum: null,

        enabled: null,

        createTime: null,

        remark: null,

        imgs: null,

        imgsArr: []
      },
      // 1增加,2修改
      formType: 1,
      formKey: 0,
      open: false,
      rules: {
        articleTitle: [
          { required: true, message: '文章标题不能为空', trigger: 'blur' }
        ],
        articleType: [
          { required: true, message: '请选择文章类型', trigger: 'change' }
        ],
        articleContent: [
          { required: true, message: '文章内容不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    onClose () {
      this.reset()
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.formKey += 1
      this.form = {
        id: null,
        articleTitle: null,
        articleType: null,
        articleContent: null,
        readNum: null,
        sortNum: null,
        enabled: null,
        createTime: null,
        remark: null,

        imgs: null,

        imgsArr: []
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd () {
      this.reset()
      this.formType = 1
      this.formTitle = '添加'
      this.form.articleType = 1
      this.$nextTick(() => {
        this.open = true
      })
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getArticle({ id }).then(response => {
        this.form = { ...response.data }
        this.form.imgsArr = this.buildImgsArrForUpload(this.form.imgs)
        this.formTitle = '修改'
        this.$nextTick(() => {
          this.open = true
        })
      })
    },
    /** 提交：去掉仅前端使用的 imgsArr */
    buildSubmitPayload () {
      const payload = { ...this.form }
      delete payload.imgsArr
      return payload
    },

    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          const payload = this.buildSubmitPayload()
          if (this.form.id !== undefined && this.form.id !== null) {
            updateArticle(payload).then(() => {
              this.$message.success('修改成功', 3)
              this.reset()
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addArticle(payload).then(() => {
              this.$message.success('新增成功', 3)
              this.reset()
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },

    /** 封面回显：与 imgs 字段一致，多图时仅展示第一张供编辑 */
    buildImgsArrForUpload (imgs) {
      if (!imgs) {
        return []
      }
      const first = String(imgs).split(',')[0].trim()
      if (!first) {
        return []
      }
      return [{
        uid: guid(8, 10),
        name: first,
        status: 'done',
        halfUrl: first,
        url: first,
        path: first
      }]
    },

    getImg (info, fieldName) {
      if (typeof info === 'string') {
        if (info) {
          this.form[fieldName] = info
          this.form.imgsArr = [{
            uid: guid(8, 10),
            status: 'done',
            url: info,
            path: info,
            halfUrl: info
          }]
        } else {
          this.form[fieldName] = ''
          this.form.imgsArr = []
        }
        return
      }
      if (!info || !Array.isArray(info) || info.length === 0) {
        this.form[fieldName] = ''
        this.form.imgsArr = []
        return
      }
      const firstFile = info[0]
      const imageUrl = firstFile.url || firstFile.path || firstFile.halfUrl
      if (imageUrl) {
        this.form[fieldName] = imageUrl
        this.form.imgsArr = info
      } else {
        this.$message.error('获取图片地址失败，请重试')
      }
    }
  }
}
</script>
